module.exports = __webpack_public_path__ + "static/media/vinyl.32b884d0.jpg";